"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabelTappableArea = exports.StyledLabel = exports.StyledInput = exports.StyledCheckbox = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tappablearea = require("../../fuse-tappable-area/src/tappablearea");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledCheckbox = exports.StyledCheckbox = _styledComponents["default"].div.attrs({
  className: 'fuse-checkbox__base-checkbox',
  'data-testid': 'fuse-checkbox__base-checkbox'
}).withConfig({
  displayName: "styled-baseinput__StyledCheckbox",
  componentId: "sc-yduvl8-0"
})(["align-items:center;display:flex;height:fit-content;"]);
var StyledInput = exports.StyledInput = _styledComponents["default"].input.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['dataTestId'].includes(prop);
  }
}).attrs({
  className: 'fuse-checkbox__input',
  'data-testid': 'fuse-checkbox__input'
}).withConfig({
  displayName: "styled-baseinput__StyledInput",
  componentId: "sc-yduvl8-1"
})(["opacity:0;position:absolute;&&{outline:none;}"]);
var StyledLabel = exports.StyledLabel = _styledComponents["default"].label.attrs({
  className: 'fuse-checkbox__label',
  'data-testid': 'fuse-checkbox__label'
}).withConfig({
  displayName: "styled-baseinput__StyledLabel",
  componentId: "sc-yduvl8-2"
})(["color:var(--color-global-grey100);cursor:pointer;display:flex;flex:1 1 auto;font-size:var(--font-size-1);font-weight:var(--font-weight-paragraph);position:relative;"]);
var StyledLabelTappableArea = exports.StyledLabelTappableArea = _styledComponents["default"].span.attrs({
  className: 'fuse-checkbox__tappable-area',
  'data-testid': 'fuse-checkbox__tappable-area'
}).withConfig({
  displayName: "styled-baseinput__StyledLabelTappableArea",
  componentId: "sc-yduvl8-3"
})(["display:flex;justify-content:space-between;width:100%;", ";"], _tappablearea.TappableArea);